import { observer } from 'mobx-react';

import { Table, TableColumn } from '@servicetitan/table';
import { useInvariableEffect } from '@servicetitan/react-hooks';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Stack } from '@servicetitan/design-system';

import { LoadStatus } from '../../../common/enums/load-status';
import { PhonesStore } from '../stores/phones.store';
import { ManageTenantStore } from '../../stores/manage-tenant.store';
import { DebouncedSearch } from '../../components/debounced-search/debounced-search';
import { ActionsCell } from './actions-cell';
import { ForwardToCell } from './forward-to-cell';
import { SmsCell } from './sms-cell';
import { PhonesActionsCellStore } from '../stores/phones-actions-cell.store';
import { ConfirmDeallocateDialog } from './confirm-deallocate-dialog';

export const Phones = provide({
    singletons: [PhonesStore, PhonesActionsCellStore],
})(
    observer(() => {
        const [
            { init, tableState, searchFilter, filterBySearch, loadStatus },
            { dialogForDataItem },
        ] = useDependencies(PhonesStore, PhonesActionsCellStore);
        const [{ tenant }] = useDependencies(ManageTenantStore);
        const supportCallForwarding = tenant?.partnerDetail.configs.supportCallForwarding;

        useInvariableEffect(() => {
            init();
        });

        return (
            <Stack direction="column" spacing={2}>
                <DebouncedSearch
                    onChange={filterBySearch}
                    externalValue={searchFilter}
                    placeholder="Search by Phone Number"
                />
                <Table
                    sortable
                    striped={false}
                    tableState={tableState}
                    loading={loadStatus === LoadStatus.Loading}
                >
                    <TableColumn
                        field="phoneNumber"
                        title="Phone Number"
                        editable={false}
                        width={152}
                    />
                    {supportCallForwarding !== false && (
                        <TableColumn
                            field="forwardTo"
                            cell={ForwardToCell}
                            title="Forward To"
                            width={166}
                        />
                    )}
                    <TableColumn field="sms" title="SMS" cell={SmsCell} />
                    <TableColumn field="system" title="System" width={120} editable={false} />
                    <TableColumn field="portOutStatus" title="Port Out Status" editable={false} />
                    <TableColumn field="authName" title="Auth Name" editable={false} />
                    <TableColumn
                        locked
                        field=""
                        width={150}
                        cell={ActionsCell}
                        editable={false}
                        headerCell={() => null}
                    />
                </Table>
                {!!dialogForDataItem && <ConfirmDeallocateDialog />}
            </Stack>
        );
    }),
);
